/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'services': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z" _fill="#6D9AE8"/><path pid="1" d="M10.323 16a2.58 2.58 0 11-5.162 0 2.58 2.58 0 015.162 0zM18.58 16a2.58 2.58 0 11-5.16 0 2.58 2.58 0 015.16 0zM26.839 16a2.58 2.58 0 11-5.162 0 2.58 2.58 0 015.162 0z" _fill="#fff"/>'
  }
})
